import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import {
  Container,
  PageContainer,
  Title,
  Description,
} from './ReportingNoReports.styles';

interface Props {
  hasError?: boolean;
}

export const ReportingNoReports = ({ hasError }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const emptyStateSrc = theme.isVaultVariant
    ? '/assets/empty-state.svg'
    : '/assets/empty-state-atlas.svg';
  return (
    <PageContainer>
      <Container>
        <img src={emptyStateSrc} alt="Empty state" width="100%" />
        {hasError ? (
          <>
            <Title>{t('reporting.noReports.errorTitle')}</Title>
            <Description>
              {t('reporting.noReports.errorDescription')}
            </Description>
            <Description>
              {t('reporting.noReports.errorDescriptionSecondary')}{' '}
              <a href="mailto:techsupport@vaultplatform.com">
                techsupport@vaultplatform.com
              </a>
            </Description>
          </>
        ) : (
          <>
            <Title>{t('reporting.noReports.title')}</Title>
            <Description>
              {t('reporting.noReports.description')}{' '}
              <a
                href="https://help.vaultplatform.com/en/articles/6638099-what-is-vault-platform"
                target="_blank"
                rel="noreferrer"
              >
                {t('reporting.noReports.descriptionHelpArticle')}
              </a>
            </Description>
          </>
        )}
      </Container>
    </PageContainer>
  );
};
